// ** React Import
import { forwardRef } from 'react'

// ** MUI Import
import Paper from '@mui/material/Paper'
import Autocomplete from '@mui/material/Autocomplete'

// ✅ stable Paper component (defined ONCE)
const AutocompletePaper = (props) => (
  <Paper {...props} className="custom-autocomplete-paper" />
)

const CustomAutocomplete = forwardRef((props, ref) => {
  return (
    <Autocomplete
      {...props}
      ref={ref}
      PaperComponent={AutocompletePaper}
    />
  )
})

export default CustomAutocomplete
